import { OperatorFunction, filter, map } from 'rxjs';
import { HostMessage, HostMessageType } from '../interfaces/host-message-types';
import { ExternalCommandPayload } from '../interfaces/host-message-payloads.types';
import { isExternalCommandPayload } from '../host-message-validators';

/**
 * Custom RxJS operator that filters for 'external-command' host messages
 * and extracts the validated payload.
 */
export function ofExternalCommand(): OperatorFunction<HostMessage, ExternalCommandPayload> {
  return source$ =>
    source$.pipe(
      filter(msg => msg.type === HostMessageType.ExternalCommand),
      map(msg => msg.payload),
      filter(isExternalCommandPayload)
    );
}
